function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React from 'react';
import PropTypes from 'prop-types';
import addMinutes from 'date-fns/add_minutes';
import addSeconds from 'date-fns/add_seconds';
import fecha from 'fecha';
import getHours from 'date-fns/get_hours';
import getMinutes from 'date-fns/get_minutes';
import isBefore from 'date-fns/is_before';
import setHours from 'date-fns/set_hours';
import setMinutes from 'date-fns/set_minutes';
import startOfToday from 'date-fns/start_of_today';
import startOfTomorrow from 'date-fns/start_of_tomorrow';
import flow from 'lodash.flow';
import toLower from 'lodash.tolower';
import memoizeOne from 'memoize-one';
import Icon from "./Icon";
import Select from "./Select";
var format = fecha.format;
var parse = fecha.parse;
var INVALID_DATE = new Date(undefined); // TODO consider using <input type="time" /> when better browser support.

function normalizeTime(date) {
  var time = startOfToday();
  time = setHours(time, getHours(date));
  time = setMinutes(time, getMinutes(date));
  return time;
}

function getEndTime(end, timeFormat) {
  return end ? addSeconds(normalizeTime(parse(end, timeFormat)), 1) : startOfTomorrow();
}

function getStartTime(start, timeFormat) {
  return start ? normalizeTime(parse(start, timeFormat)) : startOfToday();
}

function onInterval(time, interval) {
  return getMinutes(time) % interval === 0;
}
/** Helper for userInputProgress(). Builds a regex for parsing a time in h:mm format
 * @param isTwoDigit whether the time to parse is a two digit (eg. 10:00) or
 * one digit (eg. 1:00) hour
 * @returns regex used to parse a string
*/


function buildhmmARegex(isTwoDigit) {
  var oneDigitHourAndColon = '\\d:?';
  var twoDigitHourAndColon = '\\d\\d:?';
  var hour = isTwoDigit ? twoDigitHourAndColon : oneDigitHourAndColon;
  var m0 = '\\d';
  var m1 = '\\d';
  return new RegExp("^(?:".concat(hour, ")?(").concat(m0, ")?(").concat(m1, ")?"));
}
/** Helper for userInputProgress(). Returns whether a time is two digits in h:mm
 * format, ie. if a time is one of 12am, 10am, 11am, 12am, 10pm, 11pm
*/


function isTwoDigitHour(time) {
  return [0, 10, 11, 12, 22, 23].includes(getHours(time));
}
/** filterOption() helper for determining user input progress
 * @returns [hasTypedTens, hasTypedMin] where:
 * - hasTypedTens === true if finished typing tens place in minute (5 in 8:53)
 * - hasTypedMin === true if finished typing minute (3 in 8:53)
 */


function userInputProgress(input, time) {
  var re = buildhmmARegex(isTwoDigitHour(time));

  var _re$exec = re.exec(input),
      _re$exec2 = _slicedToArray(_re$exec, 3),
      hasTypedTens = _re$exec2[1],
      hasTypedMin = _re$exec2[2];

  return [!!hasTypedTens, !!hasTypedMin];
}

var TimeInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimeInput, _React$Component);

  var _super = _createSuper(TimeInput);

  function TimeInput(props) {
    var _this;

    _classCallCheck(this, TimeInput);

    _this = _super.call(this, props);
    _this.valueFormat = 'HH:mm';
    _this.visibleTimes = memoizeOne(function (step, timeFormat, start, end) {
      var times = [];
      var time = getStartTime(start, _this.valueFormat);
      var max = getEndTime(end, _this.valueFormat);

      do {
        times.push({
          label: format(time, timeFormat),
          value: format(time, _this.valueFormat),
          time: time
        });
        time = addMinutes(time, step);
      } while (isBefore(time, max));

      return times;
    });

    _this.onChange = function (selectedOption) {
      _this.setState({
        selectedOption: selectedOption
      });

      if (selectedOption) {
        var value = selectedOption.value,
            time = selectedOption.time;

        _this.props.onChange(value, time);
      } else {
        _this.props.onChange('', INVALID_DATE);
      }
    };

    _this.filterOption = function (_ref, input) {
      var label = _ref.label,
          time = _ref.time;
      var step = _this.props.step;

      var removeWhitespace = function removeWhitespace(str) {
        return str.replace(/\s/gi, '');
      };

      var removeLeadingZeros = function removeLeadingZeros(str) {
        return str.replace(/^0*/, '');
      };

      var inputCandidate = flow(removeWhitespace, removeLeadingZeros, toLower)(input);

      var _userInputProgress = userInputProgress(inputCandidate, time),
          _userInputProgress2 = _slicedToArray(_userInputProgress, 2),
          hasTypedTens = _userInputProgress2[0],
          hasTypedMin = _userInputProgress2[1]; // only show times on step if we havent started to type minutes


      if (!hasTypedTens && !onInterval(time, step)) return false; // only show times on step or on 10 min intervals if we havent finished typing minutes

      if (!hasTypedMin && !onInterval(time, step) && !onInterval(time, 10)) return false;
      var labelCandidate = flow( // Remove colon from option if input doesnt have one
      function (str) {
        return inputCandidate.includes(':') ? str : str.replace(/:/gi, '');
      }, removeWhitespace, removeLeadingZeros, toLower)(label);
      return labelCandidate.indexOf(inputCandidate) === 0;
    };

    var defaultValue = _this.props.defaultValue;
    _this.state = {
      selectedOption: defaultValue && _this.valueStrToOption(defaultValue)
    };
    return _this;
  }

  _createClass(TimeInput, [{
    key: "valueStrToOption",
    value: function valueStrToOption(valueStr) {
      return this.times().find(function (_ref2) {
        var value = _ref2.value;
        return value === valueStr;
      });
    }
  }, {
    key: "focus",
    value: function focus() {
      // TODO JavaScript does not allow opening selects programmatically.
      this.inputEl.focus();
    }
  }, {
    key: "defaultVisibleTimes",
    value: function defaultVisibleTimes() {
      var _this$props = this.props,
          step = _this$props.step,
          timeFormat = _this$props.timeFormat,
          min = _this$props.min,
          max = _this$props.max;
      return this.visibleTimes(step, timeFormat, min, max);
    }
  }, {
    key: "allTimes",
    value: function allTimes() {
      var _this$props2 = this.props,
          timeFormat = _this$props2.timeFormat,
          min = _this$props2.min,
          max = _this$props2.max;
      return this.visibleTimes(1, timeFormat, min, max);
    }
  }, {
    key: "times",
    value: function times() {
      var allowOtherTimes = this.props.allowOtherTimes;
      return allowOtherTimes ? this.allTimes() : this.defaultVisibleTimes();
    } // TODO replace with useMemo in react 16.7

  }, {
    key: "selectedOption",
    value: function selectedOption() {
      return this.props.value ? this.valueStrToOption(this.props.value) : this.state.selectedOption;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          allowOtherTimes = _this$props3.allowOtherTimes,
          disabled = _this$props3.disabled,
          max = _this$props3.max,
          min = _this$props3.min,
          onChange = _this$props3.onChange,
          placeholder = _this$props3.placeholder,
          step = _this$props3.step,
          timeFormat = _this$props3.timeFormat,
          props = _objectWithoutProperties(_this$props3, ["allowOtherTimes", "disabled", "max", "min", "onChange", "placeholder", "step", "timeFormat"]);

      var times = this.times();
      return (
        /*#__PURE__*/
        React.createElement(Select, _extends({}, props, {
          arrowRenderer: function arrowRenderer() {
            return (
              /*#__PURE__*/
              React.createElement(Icon, {
                name: "clock-o"
              })
            );
          },
          disabled: disabled,
          filterOption: this.filterOption,
          noResultsText: this.props.noResultsText,
          options: times,
          onChange: this.onChange,
          placeholder: placeholder,
          value: this.selectedOption()
        }))
      );
    }
  }]);

  return TimeInput;
}(React.Component);

TimeInput.propTypes = _objectSpread(_objectSpread({}, Select.propTypes), {}, {
  className: PropTypes.string,

  /** Allow entering times outside of step interval */
  allowOtherTimes: PropTypes.bool,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  max: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  min: PropTypes.string,
  noResultsText: PropTypes.string,
  step: PropTypes.number,
  // TODO? 1-60
  timeFormat: PropTypes.string,
  value: PropTypes.string
});
TimeInput.defaultProps = {
  allowOtherTimes: false,
  onChange: function onChange() {},
  step: 30,
  placeholder: 'Enter a time',
  timeFormat: 'h:mm A',
  noResultsText: 'Must be in the format HH:MM AM/PM'
};
TimeInput.displayName = "TimeInput";
export { TimeInput as default };